import React, { useEffect } from 'react'
import { useState } from "react";
import { DataGrid } from '@mui/x-data-grid';

import { makeStyles } from '@material-ui/core/styles';

import LoadingComponent from '../../../components/Loading';

import { useSelector } from "react-redux";

import {
    selectUsuarioSeleccionado,
} from "../../../redux/reducer/loginReducer";
import { getCmiSimulacrosIA, getTutoresGestion } from '../../../services/alumnos';
import DialogDiffCorreccion from './DialogDiffCorreccion';

import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '80px',
        minHeight: '100vh',
        padding: theme.spacing(4, 3),
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "90vh"
    },
    emptyContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        width: '100%',
        flexDirection: 'column',
        textAlign: 'center'
    },

}));

const getZone = (v) => {
    if (v < 20) return { color: '#15803D', icon: WarningIcon };
    if (v < 50) return { color: '#D97706', icon: ErrorOutlineIcon };
    return { color: '#DC2626', icon: CheckCircleIcon };
};
/* -------------------------------------------------------------------------- */
/*                                Componente                                  */
/* -------------------------------------------------------------------------- */
export default function TutoresSimulacrosIAContent() {
    const classes = useStyles();

    // eslint-disable-next-line no-unused-vars
    const [tutores, setTutores] = useState([]);
    const [correcciones, setCorrecciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMensaje, setLoadingMensaje] = useState("");
    const [openDiff, setOpenDiff] = useState(false);
    const [correccionSeleccionada, setCorreccionSeleccionada] = useState(null);
    const [tutorFiltrado, setTutorFiltrado] = useState(null);

    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });

    /* -------------------------------------------------------------------------- */
    /*                                  UseEffect                                 */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true);
        setLoadingMensaje("Cargando tutores");

        const usuario_id = usuarioSeleccionado.id;

        Promise.all([
            getTutoresGestion({ usuario_id }),
            getCmiSimulacrosIA({ usuario_id })
        ]).then(([respTutores, respCorrecciones]) => {
          console.log(respTutores)
          console.log(respCorrecciones)
            if (respTutores) setTutores(respTutores.tutores || []);
            if (respCorrecciones) {
                // Adaptamos a la estructura esperada por el dashboard.
                // Esperamos: { entrega_id, tutor, similar_text_variacion, ... }
                // Toleramos varias formas de llegar el dato.
                const data = Array.isArray(respCorrecciones)
                    ? respCorrecciones
                    : (respCorrecciones.resultado || []);

                const normalizadas = data.map((d, idx) => ({
                    id: idx,
                    entrega_id: String(d.entrega_id ?? d.id ?? ''),
                    tutor: d.tutor ?? d.tutor_nombre ?? d.nombre_tutor ?? 'Sin tutor',
                    tipo: d.tipo ?? d.type ?? '',
                    similar: Number(d.similar_text_variacion ?? d.similar ?? d.variacion ?? 0),
                    descripcion: d.descripcion ?? d.descripcion_entrega ?? d.titulo ?? '',
                    similar_text_variacion: Number(d.similar_text_variacion ?? d.similar ?? d.variacion ?? 0),
                    valoracion_tutor: String(d.valoracion_tutor ?? ''),
                    ultima_correccion_ia: String(d.ultima_correccion_ia ?? ''),
                    alumno_id: String(d.alumno_id ?? ''),
                    alumno_nombre: String(d.alumno_nombre ?? ''),
                    grupo_nombre: String(d.grupo_nombre ?? ''),
                })).filter(d => d.tutor && d.tutor !== 'Sin tutor');

                setCorrecciones(normalizadas);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /* -------------------------------------------------------------------------- */
    /*                                  Contenido                                 */
    /* -------------------------------------------------------------------------- */
    const mediasPorTutor = React.useMemo(() => {
        const map = {};
        correcciones.forEach(({ tutor, similar_text_variacion }) => {
            if (!map[tutor]) map[tutor] = { suma: 0, count: 0 };
            map[tutor].suma += similar_text_variacion;
            map[tutor].count += 1;
        });
        return Object.entries(map)
            .map(([tutor, { suma, count }]) => ({ tutor, media: suma / count, count }))
            .sort((a, b) => b.media - a.media);
    }, [correcciones]);

    const correccionesFiltradas = tutorFiltrado
        ? correcciones.filter(c => c.tutor === tutorFiltrado)
        : correcciones;

    const Contenido = () => {
        return (
            <div>
              0% - Textos identicos.<br />
              100% - Textos no se parecen en nada.

              {/* TABLA MEDIA POR TUTOR */}
              <div style={{ marginBottom: 32, marginTop: 24 }}>
                <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600 }}>Media de variación por tutor</h2>
                <p style={{ margin: '0 0 12px', color: '#6B7280', fontSize: 13 }}>
                    {mediasPorTutor.length} tutores · <em style={{ fontSize: 12 }}>Haz clic en una fila para filtrar</em>
                </p>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                    <thead>
                        <tr style={{ background: '#F3F4F6' }}>
                            <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, borderBottom: '1px solid #E5E7EB' }}>Tutor</th>
                            <th style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 600, borderBottom: '1px solid #E5E7EB' }}>Correcciones</th>
                            <th style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 600, borderBottom: '1px solid #E5E7EB' }}>Media variación (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {mediasPorTutor.map(({ tutor, media, count }, i) => {
                            const z = getZone(media);
                            const isSelected = tutorFiltrado === tutor;
                            return (
                                <tr
                                    key={tutor}
                                    onClick={() => setTutorFiltrado(isSelected ? null : tutor)}
                                    style={{
                                        background: isSelected ? '#DBEAFE' : i % 2 === 0 ? '#fff' : '#F9FAFB',
                                        cursor: 'pointer',
                                        outline: isSelected ? '2px solid #3B82F6' : 'none',
                                        outlineOffset: '-2px',
                                    }}
                                >
                                    <td style={{ padding: '9px 14px', borderBottom: '1px solid #E5E7EB', fontWeight: isSelected ? 600 : 400 }}>{tutor}</td>
                                    <td style={{ padding: '9px 14px', borderBottom: '1px solid #E5E7EB', textAlign: 'right', color: '#6B7280' }}>{count}</td>
                                    <td style={{ padding: '9px 14px', borderBottom: '1px solid #E5E7EB', textAlign: 'right', fontWeight: 600, color: z.color }}>{media.toFixed(1)}%</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
              </div>
              {/* DATAGRID */}
                <div className={classes.datagridPanel}>
                    <div className={classes.panelHeader} style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <h2 className={classes.panelTitle}>Tabla de correcciones</h2>
                            <p className={classes.panelSubtitle}>
                                {correccionesFiltradas.length} registros{tutorFiltrado ? ` · filtrando por "${tutorFiltrado}"` : ''}
                            </p>
                        </div>
                        {tutorFiltrado && (
                            <button
                                onClick={() => setTutorFiltrado(null)}
                                style={{
                                    padding: '6px 14px',
                                    fontSize: 13,
                                    fontWeight: 500,
                                    border: '1px solid #D1D5DB',
                                    borderRadius: 6,
                                    background: '#fff',
                                    color: '#374151',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                Quitar filtro
                            </button>
                        )}
                    </div>
                    <DataGrid
                        rows={correccionesFiltradas}
                        autoHeight
                        hideFooterPagination
                        hideFooterSelectedRowCount
                        disableSelectionOnClick
                        onRowClick={(params) => {
                            setCorreccionSeleccionada(params.row);
                            setOpenDiff(true);
                        }}
                        sx={{ '& .MuiDataGrid-row': { cursor: 'pointer' } }}
                        columns={[
                            {
                                field: 'tutor',
                                headerName: 'Tutor',
                                flex: 1,
                                minWidth: 160,
                                renderCell: ({ value }) => (
                                    <span>{value}</span>
                                )
                            },
                            // {
                            //     field: 'entrega_id',
                            //     headerName: 'ID de Entrega',
                            //     flex: 2,
                            //     minWidth: 200,
                            //     renderCell: ({ value }) => (
                            //         <span>{value}</span>
                            //     )
                            // },
                            {
                                field: 'tipo',
                                headerName: 'Tipo',
                                flex: 2,
                                minWidth: 200,
                                renderCell: ({ value }) => (
                                    <>[{value}]</>
                                )
                            },
                            {
                                field: 'descripcion',
                                headerName: 'Descripción',
                                flex: 2,
                                minWidth: 200,
                                renderCell: ({ value }) => (
                                    <span>{value}</span>
                                )
                            },
                            {
                                field: 'similar_text_variacion',
                                headerName: 'Variación (%)',
                                flex: 0.6,
                                minWidth: 130,
                                type: 'number',
                                align: 'left',
                                headerAlign: 'left',
                                renderCell: ({ value }) => {
                                    const z = getZone(value);
                                    // const label = value < 20 ? 'sin corregir' : value < 50 ? 'parcial' : 'activa';
                                    return (
                                        <span className={classes.variacionChip}>
                                            {/* <span style={{
                                                width: 8, height: 8, borderRadius: '50%',
                                                background: z.color, flexShrink: 0, display: 'inline-block'
                                            }} /> */}
                                            <span style={{ color: z.color }}>{value.toFixed(1)}%</span>
                                            {/* <span style={{ color: '#525252', fontWeight: 400, fontSize: 10 }}>{label}</span> */}
                                        </span>
                                    );
                                }
                            },
                            {
                                field: 'alumno_nombre',
                                headerName: 'Alumno',
                                flex: 2,
                                minWidth: 200,
                            },
                            {
                                field: 'grupo_nombre',
                                headerName: 'Grupo',
                                flex: 2,
                                minWidth: 200,
                            },
                        ]}
                    />
                </div>

                <DialogDiffCorreccion
                    openModal={openDiff}
                    setOpenModal={setOpenDiff}
                    correccion={correccionSeleccionada}
                />
            </div>
        );
    };

    /* -------------------------------------------------------------------------- */
    /*                                   Return                                   */
    /* -------------------------------------------------------------------------- */
    return (
        <div className={classes.container}>
            {
                (loading ?
                    <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
                    :
                    <Contenido />
                )
            }
        </div>
    );
}